'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface QuickActionButtonProps {
  cartItemCount?: number;
  onOrderNow?: () => void;
  onViewCart?: () => void;
  className?: string;
}

const QuickActionButton = ({
  cartItemCount = 0,
  onOrderNow = () => {},
  onViewCart = () => {},
  className = '',
}: QuickActionButtonProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > 300) {
        if (currentScrollY > lastScrollY) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      } else {
        setIsVisible(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const handleClick = () => {
    if (cartItemCount > 0) {
      onViewCart();
    } else {
      onOrderNow();
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`fixed bottom-6 right-6 z-[150] flex h-14 items-center gap-2 rounded-full bg-primary px-6 shadow-cta transition-all duration-250 ease-out hover:shadow-lg lg:hidden ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
      } ${className}`}
      aria-label={cartItemCount > 0 ? 'View cart' : 'Order now'}
    >
      {cartItemCount > 0 ? (
        <>
          <div className="relative">
            <Icon
              name="ShoppingCartIcon"
              size={24}
              className="text-primary-foreground"
            />
            <div className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-warning">
              <span className="text-xs font-bold text-warning-foreground">
                {cartItemCount > 9 ? '9+' : cartItemCount}
              </span>
            </div>
          </div>
          <span className="font-cta text-base font-bold text-primary-foreground">
            View Cart
          </span>
        </>
      ) : (
        <>
          <Icon
            name="ShoppingBagIcon"
            size={24}
            className="text-primary-foreground"
          />
          <span className="font-cta text-base font-bold text-primary-foreground">
            Order Now
          </span>
        </>
      )}
    </button>
  );
};

export default QuickActionButton;